import { all } from "redux-saga/effects";
import externalDataSaga from "store/external-data/externalDataSaga";
import urlSaga from "./custom-url/urlSaga";;

export default function* rootSaga() {
  yield all([...externalDataSaga, ...urlSaga]);
}
